// extracted by mini-css-extract-plugin
export var cardIcon = "_73-4";
export var checkboxCard = "_73-0";
export var checkboxCardSelected = "_73-3";
export var disabled = "_73-1";
export var outerBorder = "_73-2";
export var spacerMedium = "_73-7";
export var spacerSmall = "_73-6";
export var spacerXsmall = "_73-5";